import React from "react";
import { Container, Box, Grid, GridItem, Text } from "@chakra-ui/react";

import Card from "../Card";
import Arrow from "../arrow";
import Completedapi from "./completedapi";

const Completed = () => {
  return (
    <Container maxW="100%" height="100vh" bgColor="white" marginLeft="0px">
      <Grid templateColumns="repeat(4, 1fr)" gap={4} marginLeft="0px">
        {Completedapi.map((value, index) => {
          return (
            <GridItem key={index} marginBottom="30px">
              <Card
                key={index}
                imgsrc={value.imgsrc}
                title={value.title}
                profile={value.profile}
                name={value.name}
              />
            </GridItem>
          );
        })}
      </Grid>
    </Container>
  );
};

export default Completed;
